import css from './OrderSummary.module.css';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { TEMPLATE_PRICE } from '@shared/Constants/TemplatePrice';
import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';
import { GetHostEmail } from '@shared/Helpers/CBGetAttributes/GetHostEmail/GetHostEmail';
import { GetIdStoreHost } from '@shared/Helpers/CBGetAttributes/GetIdStoreHost/GetIdStoreHost';
import {
    notifyErrorCustom,
    notifySuccessCustom,
} from '@shared/Widgets/ToastNotifications/ToastNotifications';
import { SubmitPaymentForm } from '@shared/Helpers/SubmitPaymentForm';
import { ROUTES } from '@configs/AppRoutes';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { CustomProjectInfoViewModel } from '@viewModels/CustomProjectInfoViewModel';
import { useNavigate } from 'react-router-dom';

export const OrderSummary = () => {
    const { fetchPurchaseTemplate, currentTemplate } = useTemplatesViewModel();
    const email = GetHostEmail();
    const idStore = GetIdStoreHost() || '0';
    const templatePrice = currentTemplate?.paid ? TEMPLATE_PRICE : '0.00';

    const navigate = useNavigate();

    const projectViewModel = new CustomProjectInfoViewModel();

    const handleProceedToPayment = async () => {
        if (currentTemplate?.paid) {
            if (!email || email === '') {
                notifyErrorCustom('Error, please try again later');
                return;
            }

            const response = await fetchPurchaseTemplate(idStore, email);

            if (
                response.error ||
                (response.data?.errors && response.data?.errors.length > 0)
            ) {
                notifyErrorCustom('Error, please try again later');
                return;
            }

            const rawHtml = response.data?.html as string;

            SubmitPaymentForm(rawHtml);
        } else {
            const success =
                await projectViewModel.createNewProjectWithFreeTemplate([
                    Number(currentTemplate?.id),
                ]);

            if (success.error) {
                notifyErrorCustom(
                    success.message ?? 'Failed to add template to new project'
                );
                return;
            }

            const projectId = success.data?.id ?? 0;

            navigate(
                ROUTES.STEP1.getPath(
                    StepsViewModeEnum.PROJECT,
                    String(projectId)
                )
            );

            notifySuccessCustom('Successfully added template to new project!');
        }
    };

    return (
        <div className={css.summary}>
            <div className={css.summaryTitle}>Order Summary</div>

            <div className={css.summaryList}>
                <div className={`${css.listItem}`}>
                    <span>Subtotal:</span>
                    <span className={css.dashedLine}></span>
                    <span>R {templatePrice}</span>
                </div>
                <div className={`${css.listItem} ${css.total}`}>
                    <span>Total (VAT incl.):</span>
                    <span className={css.dashedLine}></span>
                    <span className={css.totalPrice}>R {templatePrice}</span>
                </div>
            </div>

            <BasicButton
                onClick={handleProceedToPayment}
                extraClassName={css.summaryBtn}
            >
                {currentTemplate?.paid
                    ? 'Place an order'
                    : 'Get template for free'}
            </BasicButton>
        </div>
    );
};

export default OrderSummary;
